import { Component } from "@angular/core";

@Component({
	selector: "caass-schoolsettings",
	templateUrl: "./adminsettings.component.html",
})
export class SchoolSettingsComponent {}
